module.exports = __webpack_public_path__ + "static/media/chengguo_download.45e0d036.jpg";